function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 26a3.067 3.067 0 01-2.305-1.04L.614 10.091A2.462 2.462 0 014.312 6.84l11.439 13.003a.334.334 0 00.501 0L27.691 6.84a2.462 2.462 0 113.697 3.251L18.311 24.955A3.079 3.079 0 0116.002 26z"
});

function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgArrowdown;